module.exports = __webpack_public_path__ + "newprotal/img/index-pic1.05e0c9d7.png";